<template>
  <div class="dialog-container">
    <el-dialog :visible="dialogOption.dialogTableVisible" :show-close="false">
      <g-login
        :dialogData="dialogOption.data"
        v-if="dialogOption.type === 'EVENTS_LOGIN'"
      ></g-login>
      <g-prize
        :dialogData="dialogOption.data"
        v-if="dialogOption.type === 'EVENTS_PRIZE'"
      ></g-prize>
      <g-prizeAddRess
        :dialogData="dialogOption.data"
        v-if="dialogOption.type === 'EVENTS_ADDRESS'"
      ></g-prizeAddRess>
      <g-prizExchange
        :dialogData="dialogOption.data"
        v-if="dialogOption.type === 'PRIZE_CODE'"
      ></g-prizExchange>
      <g-message
        :dialogData="dialogOption.data"
        v-if="dialogOption.type === 'MESSAGE'"
      ></g-message>
      <g-rules
        :dialogData="dialogOption.data"
        v-if="dialogOption.type === 'RULES'"
      ></g-rules>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog } from 'element-ui'
import Login from './Login'
import Prize from './Prize'
import PrizeAddRess from './PrizeAddRess'
import PrizExchange from './PrizExchange'
import Message from '../dialog/Message'
import Rules from '../dialog/Rules'
export default {
  name: 'Dialog',
  components: {
    elDialog: Dialog,
    gLogin: Login,
    gPrize: Prize,
    gPrizeAddRess: PrizeAddRess,
    gPrizExchange: PrizExchange,
    gMessage: Message,
    gRules: Rules,
  },
  computed: {
    dialogOption() {
      return this.$store.state.dialog
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  background-color: transparent;
  box-shadow: initial;
  width: 100%;
  height: 100%;
  display: table;
  margin: 0 !important;
}
/deep/.el-dialog__header {
  display: none;
}
/deep/.el-dialog__body {
  padding: 0;
  vertical-align: middle;
  display: table-cell;
}
</style>
